﻿import { Plugin } from 'ckeditor5';
import { LabeledFieldView, createDropdown, createLabeledInputNumber } from 'ckeditor5';

// #toolbar-emojis
const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <path d="M4.166666666666667 25a4.166666666666667 4.166666666666667 0 0 0 4.166666666666667 -4.166666666666667V10.416666666666668a2.0833333333333335 2.0833333333333335 0 0 1 2.0833333333333335 -2.0833333333333335H20.833333333333336a4.166666666666667 4.166666666666667 0 0 0 0 -8.333333333333334H8.333333333333334a8.333333333333334 8.333333333333334 0 0 0 -8.333333333333334 8.333333333333334v12.5a4.166666666666667 4.166666666666667 0 0 0 4.166666666666667 4.166666666666667Z" />
    <path d="M91.66666666666667 0h-12.5a4.166666666666667 4.166666666666667 0 0 0 0 8.333333333333334h10.416666666666668a2.0833333333333335 2.0833333333333335 0 0 1 2.0833333333333335 2.0833333333333335V20.833333333333336a4.166666666666667 4.166666666666667 0 0 0 8.333333333333334 0V8.333333333333334a8.333333333333334 8.333333333333334 0 0 0 -8.333333333333334 -8.333333333333334Z" />
    <path d="M79.16666666666667 70.83333333333334V29.166666666666668a8.333333333333334 8.333333333333334 0 0 0 -8.333333333333334 -8.333333333333334H29.166666666666668a8.333333333333334 8.333333333333334 0 0 0 -8.333333333333334 8.333333333333334v41.66666666666667a8.333333333333334 8.333333333333334 0 0 0 8.333333333333334 8.333333333333334h41.66666666666667a8.333333333333334 8.333333333333334 0 0 0 8.333333333333334 -8.333333333333334Zm-8.333333333333334 -2.0833333333333335a2.0833333333333335 2.0833333333333335 0 0 1 -2.0833333333333335 2.0833333333333335h-37.5a2.0833333333333335 2.0833333333333335 0 0 1 -2.0833333333333335 -2.0833333333333335v-37.5a2.0833333333333335 2.0833333333333335 0 0 1 2.0833333333333335 -2.0833333333333335h37.5a2.0833333333333335 2.0833333333333335 0 0 1 2.0833333333333335 2.0833333333333335Z" />
    <path d="M20.833333333333336 91.66666666666667H10.416666666666668a2.0833333333333335 2.0833333333333335 0 0 1 -2.0833333333333335 -2.0833333333333335V79.16666666666667a4.166666666666667 4.166666666666667 0 0 0 -8.333333333333334 0v12.5a8.333333333333334 8.333333333333334 0 0 0 8.333333333333334 8.333333333333334h12.5a4.166666666666667 4.166666666666667 0 0 0 0 -8.333333333333334Z" />
    <path d="M95.83333333333334 75a4.166666666666667 4.166666666666667 0 0 0 -4.166666666666667 4.166666666666667v10.416666666666668a2.0833333333333335 2.0833333333333335 0 0 1 -2.0833333333333335 2.0833333333333335H79.16666666666667a4.166666666666667 4.166666666666667 0 0 0 0 8.333333333333334h12.5a8.333333333333334 8.333333333333334 0 0 0 8.333333333333334 -8.333333333333334v-12.5a4.166666666666667 4.166666666666667 0 0 0 -4.166666666666667 -4.166666666666667Z" />
    <path d="M41.66666666666667 8.333333333333334h16.666666666666668a4.166666666666667 4.166666666666667 0 0 0 0 -8.333333333333334h-16.666666666666668a4.166666666666667 4.166666666666667 0 0 0 0 8.333333333333334Z" />
    <path d="M58.333333333333336 91.66666666666667h-16.666666666666668a4.166666666666667 4.166666666666667 0 0 0 0 8.333333333333334h16.666666666666668a4.166666666666667 4.166666666666667 0 0 0 0 -8.333333333333334Z" />
    <path d="M95.83333333333334 37.5a4.166666666666667 4.166666666666667 0 0 0 -4.166666666666667 4.166666666666667v16.666666666666668a4.166666666666667 4.166666666666667 0 0 0 8.333333333333334 0v-16.666666666666668a4.166666666666667 4.166666666666667 0 0 0 -4.166666666666667 -4.166666666666667Z" />
    <path d="M4.166666666666667 62.50000000000001a4.166666666666667 4.166666666666667 0 0 0 4.166666666666667 -4.166666666666667v-16.666666666666668a4.166666666666667 4.166666666666667 0 0 0 -8.333333333333334 0v16.666666666666668a4.166666666666667 4.166666666666667 0 0 0 4.166666666666667 4.166666666666667Z" />
</svg>`;

export default class ImageSpacing extends Plugin {
    static get pluginName() { return "ImageSpacing" };

    static get requires() { return ['ImageUtils'] }

    init() {
        const editor = this.editor;
        const { t } = editor.locale;
        const imageUtils = editor.plugins.get('ImageUtils');

        editor.model.schema.extend('imageInline', {
            allowAttributes: ['hspace', 'vspace']
        });

        _registerConversions(editor, imageUtils);

        // Add a button to the component factory so it is available for the editor.
        editor.ui.componentFactory.add('imageSpacing', locale => {
            const toolbarItem = createDropdown(locale);

            toolbarItem.buttonView.set({
                label: t('Image spacing'),
                withText: false,
                icon: svg,
                tooltip: t('Image spacing'),
                class: 'spacing'
            });

            const hspaceView = _createField('hspace', locale, editor);
            const vspaceView = _createField('vspace', locale, editor);

            hspaceView.set('label', t('HSpace'));
            vspaceView.set('label', t('VSpace'));

            toolbarItem.panelView.children.add(hspaceView);
            toolbarItem.panelView.children.add(vspaceView);

            toolbarItem.on('change:isOpen', (evt, name, value, oldValue) => {
                if (value === true && oldValue === false) {
                    let selectedImage = editor.model.document.selection.getSelectedElement();
                    hspaceView.fieldView.value = selectedImage.getAttribute('hspace') || '';
                    vspaceView.fieldView.value = selectedImage.getAttribute('vspace') || '';

                    hspaceView.set('selectedImage', selectedImage);
                    vspaceView.set('selectedImage', selectedImage);
                }
            });

            return toolbarItem;
        });
    }
}

function _registerConversions(editor, imageUtils) {
    editor.conversion.for('upcast')
        .attributeToAttribute({
            view: {
                name: 'img',
                key: 'hspace',
            },
            model: {
                key: 'hspace',
            }
        })
        .attributeToAttribute({
            view: {
                name: 'img',
                key: 'vspace',
            },
            model: {
                key: 'vspace',
            }
        });

    editor.conversion.for('downcast')
        .attributeToAttribute({
            model: {
                name: 'imageInline',
                key: 'hspace'
            },
            view: 'hspace'
        })
        .attributeToAttribute({
            model: {
                name: 'imageInline',
                key: 'vspace'
            },
            view: 'vspace'
        });

    // convert hspace/vspace to margin for editing view
    editor.conversion.for('editingDowncast').add(dispatcher => {
        dispatcher.on(`attribute:hspace:imageInline`, (evt, data, conversionApi) => {
            const viewWriter = conversionApi.writer;
            const viewElement = conversionApi.mapper.toViewElement(data.item);

            if (data.attributeNewValue == null || data.attributeNewValue == undefined || data.attributeNewValue == '0' || data.attributeNewValue == '') {
                viewWriter.removeStyle('margin-left', viewElement);
                viewWriter.removeStyle('margin-right', viewElement);
            }
            else {
                viewWriter.setStyle('margin-left', `${data.attributeNewValue}px`, viewElement);
                viewWriter.setStyle('margin-right', `${data.attributeNewValue}px`, viewElement);
            }
        });

        dispatcher.on(`attribute:vspace:imageInline`, (evt, data, conversionApi) => {
            const viewWriter = conversionApi.writer;
            const viewElement = conversionApi.mapper.toViewElement(data.item);

            if (data.attributeNewValue == null || data.attributeNewValue == undefined || data.attributeNewValue == '0' || data.attributeNewValue == '') {
                viewWriter.removeStyle('margin-top', viewElement);
                viewWriter.removeStyle('margin-bottom', viewElement);
            }
            else {
                viewWriter.setStyle('margin-top', `${data.attributeNewValue}px`, viewElement);
                viewWriter.setStyle('margin-bottom', `${data.attributeNewValue}px`, viewElement);
            }
        });
    });
}

function _createField(attributeName, locale, editor) {
    const viewElement = new LabeledFieldView(locale, createLabeledInputNumber);

    viewElement.set({
        class: 'ck ck-form__row',
    });
    viewElement.fieldView.set({
        min: 0,
        max: 500,
        step: 1,
        value: 0,
        inputMode: 'numeric',
        tabIndex: -1
    });
    viewElement.fieldView.on('input', () => {
        if (viewElement.fieldView.element.checkValidity()) {
            editor.model.enqueueChange({ isUndoable: true }, writer => {
                writer.setAttribute(attributeName, viewElement.fieldView.element.value, viewElement.selectedImage);
            });
        }
    });

    return viewElement;
}